import { MenuProps, Menu as MuiMenu } from "@mui/material";

type Props = MenuProps;

export const Menu = ({ children, ...props }: Props) => {
  return <MuiMenu {...props}>{children}</MuiMenu>;
};
